import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MetaService } from './meta.service';
import { PoiService } from './poi/poi.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit, OnDestroy {
  muncipalities = [
    "Attersee",
    "Ebensee",
    "Gampern",
    "Gosau",
    "Nußdorf",
    "Schörfling",
    "Seewalchen",
    "St. Georgen",
    "St. Gilgen",
    "Steinbach",
    "Strobl",
    "Unterach",
    "Vöcklabruck",
    "Weißenbach",
    "Weyregg"];
  sub = new Subscription();

  constructor(
    private metaService: MetaService,
    private poiService: PoiService
    ) { }

  ngOnInit() {
    this.sub.add(this.poiService.loadPois().subscribe(pois => {
      this.muncipalities = [...new Set(pois.map(e => e.municipality))].sort();
    }));
  }

  getUrl(urlString: string) {
    return this.metaService.slugify(urlString);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
